import {
  PaymentTypeEnum,
  RegistrationApprovalEventsEnum,
  RegistrationApprovalStatesEnum,
  ExamEventsEnum,
  ResultTypeEnum,
} from '../enum/license-exam.enum';

export type PaginateList<T extends Record<string, unknown>> = {
  total: number;
  totalPages: number;
  limit: number;
  items: T[];
  data: T[];
  docs: T[];
  hasNextPage: boolean;
  hasPrevPage: boolean;
  totalNumbers?: number;
  totalDocs?: number;
};
class ExamBaseParam {
  examType?: string;
  examDate?: string;
  examCode?: string;
  examCentre?: string;
  public examName?:
    | {
        [key: string]: string;
      }
    | string;
  [key: string]: unknown;
}

class ListResBaseParam {
  limit = 10;
  page = 1;
  sortBy?: string;
  orderBy?: string;
}

class langBaseParam {
  lang?: string;
}

export interface examOptionsParam extends langBaseParam {
  examType?: string;
}

export interface examScheduleParam extends ExamBaseParam, ListResBaseParam, langBaseParam {
  examName: string;
}

export interface examResultsParam extends ExamBaseParam, ListResBaseParam {
  examResults?: any;
  candidateId?: any;
}

export interface examPassingRateParam extends ExamBaseParam, ListResBaseParam {
  examResults?: any;
  candidateId?: any;
}

export interface TimeSlotsListItem extends ExamBaseParam {
  id: string;
  lastUpdatedTime: string;
  lastUpdatedBy: string;
  startTime?: string;
  endTime?: string;
  examQuota?: number;
  examRemainingQuota?: number;
  examName?: {
    [key: string]: string;
  };
  activateStatus: ScheduleStatus;
}
export interface ExamResultsFileData extends ExamBaseParam {
  StartTime?: number;
  EndTime?: number;
  isPresent?: boolean;
  result?: string;
  score?: string;
}
export interface ExamScheduleFileData extends ExamBaseParam {
  startTime?: string;
  endTime?: string;
  lastRegistrationDate?: string;
  quota?: number;
  minimumQuota?: number;
  iiqeReminderMessageChi?: string;
  iiqeReminderMessageEn?: string;
  isDeleted?: boolean;
}

export type UpdateExamScheduleData = Pick<
  ExamScheduleFileData,
  | 'startRegistrationDate'
  | 'lastRegistrationDate'
  | 'quota'
  | 'minimumQuota'
  | 'remarks'
  | 'iiqeReminderMessageChi'
  | 'iiqeReminderMessageEn'
>;

export interface LicenseExamResultsListParam {
  ExamType?: string;
  ExamCode: string;
  ExamNameLocal?: string;
  ExamNameEnglish: string;
  ExamDate?: string;
  StartTime?: number;
  EndTime?: number;
  ExamCentre?: string;
  LastRegistrationDate?: string;
  Quota?: number;
  MinimumQuota?: number;
  isDeleted?: boolean;
}

export interface LicenseExamRegistrationExportParam {
  examType?: string;
  examName?: string;
  lang?: string;

  examDateFrom?: any;
  examDateTo?: any;
  status?: string[];
  orNumber?: string;
  registrationId?: string;
  applicantId?: string;
  firstName?: string;
  lastName?: string;
  examResult?: string;

  examDate?: string;
  examCode?: string;
  examCentre?: string;
  fields?: string;
}

export interface Operator {
  operatorId: string;
  operatorName: string;
  operatorRole: string;
}

export interface RegistrationApprovalHistory {
  status: string;
  event: string;
  remark: string;
  operator: Operator;
  updatedAt: string;
}

export interface UpdateExamResult {
  result: string;
  score: string;
}

export interface UpdateExamineeDetails {
  firstname: string;
  lastname: string;
  identityDocumentType?: string;
  identityDocumentNumber: string;
  birthday: string;
  localName?: string | null;
  hkId?: string;
}

export interface RegistrationItem extends ExamBaseParam {
  examName?: {
    [key: string]: string;
  };
  examDateFrom?: Date | null;
  examDateTo?: Date | null;
  orNumber?: string;
  registrationId?: string;
  applicantId?: string;
  firstname?: string;
  lastname?: string;
  isPresent: boolean;
  result?: string;
  score?: string;
  startTime?: string;
  endTime?: string;
  submissionTime?: string;
  address?: string;
  examFeeReceiptNo: string;
  licenseFeeReceiptNo: string;
  registrationApprovalStates: string;
  lastUpdatedBy: string;
  lastUpdatedAt: string;
  operationHistoryList: RegistrationApprovalHistory[];
}

export interface RegistrationItemDetail extends RegistrationItem {
  region: string;
  channel: string;
  id: string;
  examFeeReceiptDate: string;
  paymentType: string;
  licenseFeeReceiptDate: string;
  licenseFeeOrNumberUsedBefore: boolean;
  examFeeOrNumberUsedBefore: boolean;
}

export type statusType = keyof typeof RegistrationApprovalStatesEnum;
export type approvalEventType = keyof typeof RegistrationApprovalEventsEnum;
export type eventType = keyof typeof ExamEventsEnum;
export type resultType = keyof typeof ResultTypeEnum;
export type PaymentType = keyof typeof PaymentTypeEnum;

export interface RegistrationListParam extends ExamBaseParam, ListResBaseParam, langBaseParam {
  examCodes?: [];
  examDateFrom?: string;
  examDateTo?: string;
  registrationApprovalStates?: statusType[];
  orNumbers?: string;
  registrationIds?: string;
  applicantIds?: string;
  firstnames?: string;
  lastnames?: string;
  result?: string;
  candidateId?: string;
}

// PHKL Custom -s
export interface RegistrationExamineeSearchParam {
  examCode: string;
  examType: string;
  firstName: string;
  lastName: string;
  chiName: string;
  identityDocumentNumber: string;
  candidateCode: string;
  agentCode: string;
  recruiterCode: string;
}

export enum AccountTypeEnum {
  Candidate = 'Candidate',
  Agent = 'Agent',
}

export enum AccountStatusEnum {
  Active = 'Active',
}

export interface SearchRegistrationExamineeResponseItem {
  examineeId: string;
  enName: string;
  chiName: string;
  accountType: AccountTypeEnum;
  recruiterCode: string | null;
  recruiterName: string | null;
  accountStatus: AccountStatusEnum;
  firstname: string;
  lastname: string;
  localName: string;
  noChineseName: boolean;
  hkId: 'Y' | 'N';
  identityDocumentNumber: string;
  gender: string;
  birthday: string;
  countryCode: string | null;
  phoneNumber: string | null;
  email: string;
}

export interface ExamPaperApiItem {
  examType: string;
  examCode: string;
  examName: {
    en?: string;
    'zh-Hant'?: string;
  };
  registrationStatus: string;
  canRegister: boolean;
}

export interface ExamPaperApiResponse {
  F?: ExamPaperApiItem[];
  S?: ExamPaperApiItem[];
}

export interface RegistrationExamVenueOptionParams {
  examType: string;
  examCode: string;
  examineeId: string;
}

export interface RegistrationExamListParam {
  examType: string;
  examCode: string;
  examCentre: string;
  examineeId: string;
  year?: number;
  month?: number;
}

export interface RegistrationExamDropdownItem {
  year: number;
  months: number[];
}

export interface RegistrationExamListItem {
  examDate: string;
  startTime: string;
  endTime: string;
  examMode: string;
  quota: number;
  remainingQuota: number;
  scheduleId: string;
}

export interface RegistrationExamListResponse {
  dropdownList: RegistrationExamDropdownItem[];
  examList: RegistrationExamListItem[];
}

export interface RegisterExamRequest {
  examScheduleId: string;
  examineeId: string;
  evidenceIds?: string[];
  firstname: string;
  lastname: string;
  identityDocumentType: string;
  identityDocumentNumber: string;
  gender: string;
  birthday: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
  localName: string;
  noChineseName: boolean;
}
// PHKL Custom -e

export enum CreateScheduleFields {
  examCode = 'examCode',
  examType = 'examType',
  examMode = 'examMode',
  sessionId = 'sessionId', //only for phkl
  deviceType = 'deviceType',
  examNameEnglish = 'examNameEnglish',
  examNameLocal = 'examNameLocal',
  examDate = 'examDate',
  examCentre = 'examCentre',
  startTime = 'startTime',
  endTime = 'endTime',
  lastRegistrationDate = 'lastRegistrationDate',
  startRegistrationDate = 'startRegistrationDate',
  quota = 'quota',
  remainingQuota = 'minimumQuota',
  address = 'address',
  examFee = 'examFee',
  currencyCode = 'currencyCode',
  remark = 'remarks',
  iiqeReminderMessageChi = 'iiqeReminderMessageChi',
  iiqeReminderMessageEn = 'iiqeReminderMessageEn',
}

export enum CreateRegistrationFields {
  examCode = 'examCode',
  examType = 'examType',
  examMode = 'examMode',
  examNameEnglish = 'examNameEnglish',
  examNameLocal = 'examNameLocal',
  examDate = 'examDate',
  examCentre = 'examCentre',
  startTime = 'startTime',
  endTime = 'endTime',
  address = 'address',
  registrationId = 'registrationId',
  applicantId = 'applicantId',
  firstname = 'firstname',
  lastname = 'lastname',
  result = 'result',
  score = 'score',
}

export type GetScheduleResponse = {
  region: string;
  channel: string;
  id: string;
  examType: string;
  examCode: string;
  examName: Record<string, any>;
  examMode: string;
  examDate: string;
  startTime: string;
  endTime: string;
  examCentre: string;
  address: string;
  startRegistrationDate: string;
  lastRegistrationDate: string;
  quota: number;
  minimumQuota: number;
  remainingQuota: number;
  updatedBy: string;
  lastUpdatedDate: string;
  isDeleted: boolean;
  remarks: string;
  baseExamInfo: BaseExamInfo;
  deviceType: string;
  examFee: string;
  examFeeCurrencyCode: string;
  sessionId?: string;
  iiqeReminderMessageChi?: string;
  iiqeReminderMessageEn?: string;
};

type BaseExamInfo = {
  region: string;
  channel: string;
  id: string;
  examType: string;
  examCode: string;
  examName: Record<string, any>;
  examDate: string;
  startTime: string;
  endTime: string;
  examCentre: string;
  address: string;
  baseExamInfo: string;
};

export enum ScheduleStatus {
  ACTIVATE = 'ACTIVATE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
export interface ApiError {
  type: string;
  errorCode: string;
  rowNum?: number;
  data?: any;
}

export interface examModesType {
  displayKey: string;
  code: string;
  deviceTypes?: string[];
  default: boolean;
}

export interface UpdateExamReportResponseDTO {
  errorRowIndexes: number[];
  errors: ApiError[];
  totalRowCount: number;
  updatedRowCount: number;
  failedRowCount: number;
}
